import { FC, PropsWithChildren } from 'react';

// Tenant theming is now loaded before React boots via Azure Blob Storage
// Configuration is available at window.__TENANT_CONFIG__
// Use the following utilities to access tenant theme:
//
// import { useTenantTheme } from '../hooks/useTenantTheme';
// import { getTenantLogoUrl, getThemeVar } from '../util/tenantTheme';
//
// const MyComponent: FC = () => {
//   const tenantConfig = useTenantTheme();
//   const logoUrl = getTenantLogoUrl();
//   const brandColor = getThemeVar('brandColor');
//
//   return (
//     <div style={{ color: brandColor }}>
//       <img src={logoUrl} alt={tenantConfig?.logo?.altText} />
//     </div>
//   );
// };
//
// CSS variables are automatically applied to :root by the pre-bootstrap script
// See src/connect-carrier/tenant-assets/README.md for more information

// ts-unused-exports:disable-next-line
export const TenantConfig: FC<PropsWithChildren<unknown>> = ({ children }) => {
  return <>{children}</>;
};
